<template>
    <div class="map-editor-wrapper">
        <table class="simple-tbl">
            <thead class="head">
            <tr class="row">
                <th class="indicator">&nbsp;</th>
                <th>Key</th>
                <th>Value</th>
                <th v-if="editable" class="btns-col">
                    <i class="el-icon-plus" style="margin-left: 9px; cursor: pointer;" @click="addItem()"></i>
                </th>
            </tr>
            </thead>
            <tbody class="body" v-if="editable">
            <tr class="row" v-for="(item, indx) in itemList">
                <td class="indicator">
                    <el-checkbox size="mini" v-model="item.checked"></el-checkbox>
                </td>
                <td class="editable">
                    <input :class="{'invalid' : !item.checked}" class="input" type="text" v-model="item.key"/>
                </td>
                <td class="editable">
                    <input :class="{'invalid' : !item.checked}" class="input" type="text" v-model="item.val"/>
                </td>
                <td class="btns-col">
                    <i class="el-icon-close" style="cursor: pointer;" @click="delItem(indx)"></i>
                </td>
            </tr>
            </tbody>
            <tbody v-else="" class="body">
            <tr class="row" v-for="(item, indx) in itemList" @click="hanldeItemClick(indx)" @dblclick="hanldeItemDblClick(indx)" :class="{'selected' : isItemSelected(item)}">
                <td class="indicator">
                    {{ indx + 1 }}
                </td>
                <td>
                    {{ item.key }}
                </td>
                <td>
                    {{ item.val }}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue } from '../../app.vues'

    function mapToList(map) {
        map = map || {};
        let list = [];
        for(let key in map) {
            list.push({
                key: key,
                val: map[key] == null ? '' : map[key] + ''
            });
        }
        return list;
    }

    function listToMap(list, validOnly) {
        list = list || [];
        validOnly = validOnly === true;
        let map = {};
        for(let i = 0, c = list.length; i < c; i++) {
            let elem = list[i];
            if(elem.key) {
                if(validOnly && !elem.checked) {
                    continue;
                }
                map[elem.key] = elem.val == null ? '' : elem.val + '';
            }
        }
        return map;
    }

    export default {
        name: 'swb-map-editor',

        props: {
            json: {
                default: null
            },
            editable: {
                type: Boolean,
                default: true
            },
            selectable: {
                type: Boolean,
                default: false
            },
            dblClickHandler: {
                type: Function
            }
        },

        data() {
            return {
                itemList: [],
                //
                selected: null
            }
        },

        watch: {
            json(newVal, oldVal) {
                this.initData();
            }
        },

        mounted() {
            this.initData();
        },
        beforeDestroy() {
            //data
            this.itemList = null;
            //props
            this.json = null;
            this.dblClickHandler = null;
        },

        methods: {
            initData() {
                let tmpValue = null;
                if(this.json != null) {
                    try {
                        if(typeof this.json == 'string') {
                            tmpValue = JSON.decode(this.json);
                        }
                        else {
                            tmpValue = this.json;
                        }
                    }
                    catch(ex) {
                        //
                    }
                }
                if(tmpValue == null || !Utils.isPlainObject(tmpValue)) {
                    tmpValue = {};
                }
                else {
                    tmpValue = Utils.merge(tmpValue);
                }
                //
                let itemList = mapToList(tmpValue);
                if(this.editable) {
                    itemList.forEach(function (item) {
                        item.checked = true;
                    });
                }
                //
                this.itemList = itemList;
            },
            getSelected() {
                return this.selected;
            },
            isItemSelected(item) {
                return item == this.selected;
            },
            hanldeItemClick(index) {
                if(this.selectable) {
                    this.selected = this.itemList[index];
                }
            },
            hanldeItemDblClick(index) {
                if(this.selectable) {
                    this.selected = this.itemList[index];
                    //
                    if(this.dblClickHandler) {
                        this.dblClickHandler.call(this.$parent, this.selected);
                    }
                }
            },
            delItem(index) {
                let itemList = this.itemList;
                itemList.removeAt(index);
                this.itemList = itemList.clone();
            },
            addItem() {
                let itemList = this.itemList;
                itemList.push({
                    key: '',
                    val: '',
                    checked: true
                });
                this.itemList = itemList.clone();
            },
            getData() {
                return listToMap(this.itemList, this.editable);
            }
        }
    }

</script>

<style>
    .map-editor-wrapper .simple-tbl {
        width: 100%;
    }

    .map-editor-wrapper .simple-tbl .indicator, .map-editor-wrapper .simple-tbl .btns-col {
        text-align: center;
        width: 50px;
    }

    .map-editor-wrapper .simple-tbl .body .editable {
        padding: 0;
    }

    .map-editor-wrapper .simple-tbl .body .row.selected {
        background-color: #FFEFE5;
    }

    .map-editor-wrapper .simple-tbl .body .input {
        width: 100%;
        height: 100%;
        border: none;
    }

    .map-editor-wrapper .simple-tbl .body .input.invalid {
        color: gray;
        font-style: italic;
    }
</style>



// WEBPACK FOOTER //
// src/compo/ctrl/MapEditor.vue